import { render, staticRenderFns } from "./CountersValues.vue?vue&type=template&id=acaffe06&"
import script from "./CountersValues.vue?vue&type=script&lang=ts&"
export * from "./CountersValues.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports